import { defineStore } from 'pinia';
import { signupToChallenges } from '../api/SignupApi';
import * as LoginApi from '../api/loginApi';
import Segment from '../Segment';
import { LoginError } from '../types/loginError';

const STEPS = { EnterNameStep: 0, EnterEmailStep: 1, EnterPhoneNumberStep: 2, EnterCodeStep: 3 };

interface SignupState {
  loading: boolean;
  memberAlreadyExists: boolean,
  firstName: string,
  lastName: string,
  email: string,
  phoneNumber: string,
  enableMarketingEmails: boolean,
  currentStep: number,
}

export const useSignupStore = defineStore('signup', {
  state: (): SignupState => ({
    loading: false,
    memberAlreadyExists: false,
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    enableMarketingEmails: true,
    currentStep: STEPS.EnterNameStep,
  }),
  getters: {
    enterNameStep: state => state.currentStep === STEPS.EnterNameStep,
    enterEmailStep: state => state.currentStep === STEPS.EnterEmailStep,
    enterPhoneNumberStep: state => state.currentStep === STEPS.EnterPhoneNumberStep,
    enterCodeStep: state => state.currentStep === STEPS.EnterCodeStep,
  },
  actions: {
    nextStep() {
      this.currentStep += 1;
    },
    async signup(challengeTag: string, riseupAccountId?: number, challenger?: boolean): Promise<void> {
      this.loading = true;
      if (riseupAccountId) {
        if (!challenger) {
          await LoginApi.updateChallengesProduct();
          Segment.trackUserGot('Signup_ChallengesProduct_Added');
        }
        this.memberAlreadyExists = true;
      }

      await signupToChallenges({
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        enableMarketingEmails: this.enableMarketingEmails,
        challengeTag,
      });
      Segment.trackUserGot('Signup_Success');
      this.loading = false;
    },
    setEmail(email: string) {
      this.email = email;
    },
    setFirstName(firstName: string) {
      this.firstName = firstName;
    },
    setLastName(lastName: string) {
      this.lastName = lastName;
    },
    setPhoneNumber(phoneNumber: string) {
      this.phoneNumber = phoneNumber;
    },
    setEnableMarketingEmails(enableMarketingEmails: boolean) {
      this.enableMarketingEmails = enableMarketingEmails;
    },
  },
});
